import { useCallback, useEffect, useMemo, useReducer } from 'react';
import _ from 'lodash';
import { Loading } from '../../components/Loading';
import { QuizAnswerView } from './QuizAnswerView';
import { useMutation } from '@tanstack/react-query';
import Api, { errorToast } from 'utils/api/Api';


const initialState = {
    wordArray:[],
    columnCount:5,
    rowCount:5,
    currentQuizIndex:0,
    answer:[],
    answerState:'',
    inputBlock:false,
};

function quizReducer(state, action) {
    return { ...state, ...action };
}

export const BookQuizComponent = ({quizData, onQuizComplete=f=>f})=>{
    const [state, setState] = useReducer(quizReducer, initialState);
        
    useEffect(() => {
        //정답, 보기, 합계
        let blockCount = quizData.blockCount;

        let columnCount = Math.ceil(Math.sqrt(blockCount));
        let rowCount = Math.ceil( blockCount/columnCount );
        blockCount = columnCount*rowCount;

        let wordArray = quizData.words.split('');
        if( wordArray.length < blockCount ){
            wordArray = [...wordArray, ...Array(blockCount-wordArray.length)];
        }
        wordArray = wordArray.map( (word, index)=>{
            let disabled = false;
            if( undefined===word ){
                word = <i className="fas fa-apple-alt"></i>;
                disabled = true;
            }
            
            return { index:index, content:word, use:false, disabled:disabled };
        });
        wordArray = _.shuffle(wordArray);

        setState({
            ...initialState,
            wordArray,
            columnCount,
            rowCount,
        });
        return ()=>{
            setState(initialState);
        }
    }, [quizData]);


    const incorrectAnswer = ()=>{
        setState({answer:[], inputBlock:false, answerState:''});
    }

    const correctAnswer = ()=>{
        let quizIndex = state.currentQuizIndex;
        state.answer.map((item)=>{
            item.use=true;
            return item;
        });
        setState({answer:[], inputBlock:false, answerState:'', currentQuizIndex: ++quizIndex });
    }

    const answerCheckMutate = useMutation({
        mutationFn:(data)=>Api.post('/api/quiz/check-answer', data),
        onSuccess:(res)=>{
            const result = res.data;
            let answerState = 'incorrect';
            if(result.checkAnswer){
                
                answerState = 'correct';
                state.answer.forEach((item)=>item.use=true);
                if(result.quizComplete){
                    // 게임완료
                    //navigate
                    quizComplete();
                }
                _.delay(correctAnswer, 500);
            }else{
                _.delay(incorrectAnswer, 500);
            }

            setState({answerState:answerState});
        },
        onError:errorToast
    });
    
    const onCellClick = useCallback((index) => {
        if(answerCheckMutate.isPending)return;
        if( state.inputBlock)return;
        // 이미 선택한 정답이면 통과
        if( state.currentQuizIndex >= quizData.quizList.length)return null;

        const word = state.wordArray[index];
        if( word.use || word.disabled)return;
        // index 비교하면 문제가 생기던데 그냥 includes로 체크
        if( state.answer.includes(word) )return;

        const quiz = quizData.quizList[state.currentQuizIndex];
        let answer = [...state.answer];
        let inputBlock = false
        
        answer.push( word );

        if(answer.length>=quiz.answerLength){
            // 정답의 길이가 같으면 서버에 확인 해야해
            let answerStr = answer.map(item=>item.content).join('');
            answerCheckMutate.mutate({gameId:quizData.gameId, quizId:quiz.id, answer:answerStr, version:quizData.version});
            inputBlock = true;
        }
        setState({answer, inputBlock});
    }, [answerCheckMutate, quizData, state.answer, state.currentQuizIndex, state.inputBlock, state.wordArray]);

    const quizComplete = ()=>{
        //모든 퀴즈 완료
        let words = _.shuffle( state.wordArray.filter( (item)=>{return item.use===false}) );
        
        words.map( (word, key)=>{
            _.delay(function () {
                word.use = true;
                setState({wordArray:state.wordArray});
            }, 50*key);
            return word;
        });

        if( typeof onQuizComplete === 'function' ){
            setState({answer:[]})
            _.delay(onQuizComplete, words.length*55);
            // onQuizComplete();
        }
    }

    // 정답을 초기화
    const onAnswerReset = useCallback(()=>{
        setState({answer:[], answerState:''});
    }, []);
    

    //질문 화면
    const renderQuestion = useMemo(()=>{
        let quiz = quizData?.quizList[state.currentQuizIndex];
        if(!quiz)return null;
        return (
            <div className="question_area">
                <div className="question">{quiz?.question}</div>
            </div>
        )
    }, [quizData, state]);

    
    // 보기 화면
    const renderExample = useMemo(()=>{
        return (
            <div className={`examples _cell${state.columnCount} `}>
                {
                    state.wordArray.map((value, key)=>{
                        let cellItem = state.wordArray[key];
                        // 요래하면 랜덤하게 됨
                        var randColor = Math.floor(Math.random() * 5) + 1;
                        
                        return (
                            <div className={`cell ${cellItem.disabled?'use':''}  `} key={key} onClick={(event)=>onCellClick(key)}>
                                {cellItem.use && <span className="content gif"><img src={`${process.env.PUBLIC_URL}/images/common/quiz_action.gif?${key}`} alt="정답" /></span> }
                                { !cellItem.use && <span className={`content bg${randColor}`}>{cellItem.content}</span> }
                                <span className="apple"></span>
                            </div>
                        );
                    })
                }
            </div>
        )
    }, [onCellClick, state]);

    if(state.currentQuizIndex >= quizData.length)return <Loading />

    return (
        <div className="quiz_area">
            <QuizAnswerView answer={state.answer} answerState={state.answerState} answerLength={quizData?.quizList[state.currentQuizIndex]?.answerLength} onAnswerReset={onAnswerReset} />
            { renderQuestion }
            { renderExample }
        </div>
    );
}